export default "__VITE_ASSET__CGuNS$uY__"